export class CostingToolFilterValue{
    unitSystem?: string[];
    currency?: string[];
    rawMaterialGrade?: string[];
    process?: string[];
    lengthType?: string[];
    plant?: string[];
    endsCondition?: string[];
    testCondition?: string[];
    sql?: string[];
}
